import axios from 'axios'
import {router} from '../routes'


export default {
    namespaced: true,
    state:{
        slides: [],
    },
    getters: {
        slides: (state) => {
            return state.slides
        }
    },
    mutations: {
        setSlides (state, slides) {
            state.slides = slides
        },
    },
    actions: {
        async initSlides(context) {
            const slides = (await axios.get(`/api/slides`)).data.data;
            context.commit('setSlides', slides);
        }
    },
};
